// Mirrors server/src/industries.js.
export const INDUSTRIES = [
  { key: 'construction', label: 'Construction' },
  { key: 'sports', label: 'Sports & Athletics (NCAA)' },
  { key: 'sports-hs', label: 'Sports & Athletics (High School)' },
  { key: 'agriculture', label: 'Agriculture' },
  { key: 'wind-energy', label: 'Wind Energy' },
  { key: 'solar-energy', label: 'Solar Energy' },
  { key: 'oil-gas', label: 'Oil & Gas' },
  { key: 'hydro', label: 'Hydropower' },
];
export const INDUSTRY_LABEL = Object.fromEntries(INDUSTRIES.map((i) => [i.key, i.label]));
export const DEFAULT_INDUSTRY = 'construction';
